import AuthService from "@/common/auth.service";
import ApiService from "@/common/api.service"
import { LOGIN, FETCH_AUTH_ROLES_DATA, RESET_AUTH_STATE, UPDATE_NEW_USER_PASSWORD } from "./actions.type";
import { SET_AUTH, SET_AUTH_ROLES_DATA, SET_AUTH_ERROR, STATE_AUTH_RESET, SET_UPDATE_USER_PASSWORD_DATA } from "./mutations.type";

const initialState = () => {
  return {
    autherror: [],
    updateuserpassworddata: {},
    isAuthenticated: (process.env.NODE_ENV == "test" ? true : false),
  }
};

export const state = initialState();

const actions = {
  async [LOGIN](context, params) {
    return await AuthService.login(params).then(response => {
      return response
    }).catch(error => {
      context.commit(SET_AUTH_ERROR, error)
      return error
    })
  },
  async [UPDATE_NEW_USER_PASSWORD](context, params) {
    return await AuthService.updatePassword(params.user, params.password)
  },
  async [FETCH_AUTH_ROLES_DATA](context) {
    return await AuthService.Token.then(response => {
      context.commit(SET_AUTH_ROLES_DATA, response)
      return response
    }).catch(error => {
      context.commit(SET_AUTH_ERROR, error)
      return error
    })
  },

  [RESET_AUTH_STATE](context) {
    context.commit(STATE_AUTH_RESET)
  }

}

const getters = {
  isAuthenticated(state) {
    return state.isAuthenticated
  },
  updateuserpassworddata(state) {
    return state.updateuserpassworddata
  }
}

const mutations = {
  [SET_AUTH](state, data) {
    if (data.response.signInUserSession) {
      state.isAuthenticated = true
      ApiService.setHeader()
    }
  },

  [SET_AUTH_ROLES_DATA](state, data) {
    if (process.env.NODE_ENV == "test") {
      state.isAuthenticated = true
    }
    else if (data != null && data.token != undefined) {
      state.isAuthenticated = (data != null && data.token != undefined && data.token != null ? true : false)
    }
  },

  [SET_UPDATE_USER_PASSWORD_DATA](state, data) {
    state.updateuserpassworddata = data
  },
  [SET_AUTH_ERROR](state, error) {
    state.autherror = error
  },

  [STATE_AUTH_RESET](state) {
    Object.assign(state, initialState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
};